module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/vi/4/5-6b36f1dd10a44c8d4376a41eec7742b1.jpg";